import React from 'react';
import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { NepBrochuresOptionId } from '~/tenants/nep/performable/brochures/NepBrochuresConfig';
import { DEMO_BROCHURES_OPTIONS } from '~/tenants/nep/performable/brochures/NepBrochuresJob';
import { NepOrderContext } from '~/tenants/nep/model/NepOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';

export default function NepBrochuresForm(_props: TenantPerformableFormProps<NepOrderContext>) {
  const [_optionName, option] = useZodFormFieldSingle<NepBrochuresOptionId>('option');

  let quantity = <></>;

  if (option) {
    const pkg = DEMO_BROCHURES_OPTIONS[option];
    quantity = (
      <FormHorizontal name="quantity" label="Quantity">
        <ZodFieldSelect
          name="quantity"
          options={Object.entries(pkg.revenue).map(([id, pkg]) => ({
            value: id,
            label: id,
          }))}
        />
      </FormHorizontal>
    );
  }

  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="option" label="Size">
        <ZodFieldSelect
          name="option"
          options={Object.entries(DEMO_BROCHURES_OPTIONS).map(([id, pkg]) => ({
            value: id,
            label: `${pkg.pages} Pages (${pkg.width} x ${pkg.height})`,
          }))}
        />
      </FormHorizontal>

      {quantity}
    </TenantPerformableConfiguration>
  );
}
